import apiShared from "modules/swiftboard/api";
import apiReminderBuilder from "../../../api";
import apiReminderRule from "../api";

const extract = (res, fallback = []) => (res.status === "fulfilled" ? res.value?.data?.data ?? fallback : fallback);

// Data of the rule editor that does not depend on the chosen trigger: triggers, channels, editor options (roles,
// preferences, your timezone), active users and companies.
export const loadRuleDependencies = async () => {
  const [triggersRes, channelsRes, optionsRes, usersRes, companiesRes] = await Promise.allSettled([
    apiReminderBuilder.getTriggerOptions(),
    apiReminderBuilder.getChannelOptions(),
    apiReminderRule.getEditorOptions(),
    apiReminderRule.getUserOptions(),
    apiShared.getAllCompanies({ limit: 500, skip: 0 }),
  ]);
  const options = extract(optionsRes, {});
  return {
    triggers: extract(triggersRes),
    channels: extract(channelsRes),
    preferenceKeys: options.preference_keys ?? [],
    roles: options.roles ?? [],
    viewerTimezone: options.timezone ?? null,
    users: extract(usersRes),
    companies: extract(companiesRes).map((c) => ({ id: c.id, name: c.company_name })),
  };
};

// Data that follows the chosen trigger: its templates (plus generic ones), the recipient types that work with its
// type, and its source (fields for "user / email from the record", subject type).
export const loadTriggerContext = async (trigger) => {
  const [templatesRes, typesRes, sourceRes] = await Promise.allSettled([
    apiReminderRule.getTemplateOptions(trigger.id),
    apiReminderRule.getRecipientTypeOptions(trigger.trigger_type),
    trigger.source_fid ? apiReminderBuilder.getSource(trigger.source_fid) : Promise.resolve(null),
  ]);
  return { templates: extract(templatesRes), recipientTypes: extract(typesRes), source: extract(sourceRes, null) };
};

// Dropdown data of the list's advanced filter.
export const loadRuleFilterDependencies = async () => {
  const [triggersRes] = await Promise.allSettled([apiReminderBuilder.getTriggerOptions()]);
  return { triggers: extract(triggersRes) };
};
